export const movieGenresTypes = [
	{
		path: 'cinema/movies/drama',
		icon: 'drama'
	},
	{
		path: 'cinema/movies/comedy',
		icon: 'comedy'
	},
	{
		path: 'cinema/movies/melodrama',
		icon: 'melodrama'
	},
	{
		path: 'cinema/movies/war',
		icon: 'war'
	},
	{
		path: 'cinema/movies/musical',
		icon: 'musical'
	},
	{
		path: 'cinema/movies/detektiv',
		icon: 'detective'
	},
	{
		path: 'cinema/movies/cartoons',
		icon: 'cartoon'
	},
	{
		path: 'cinema/movies/skazka',
		icon: 'fairyTale'
	},
	{
		path: 'cinema/movies/history',
		icon: 'historical'
	},
	{
		path: 'cinema/movies/adventure',
		icon: 'adventures'
	},
	{
		path: 'cinema/movies/thriller',
		icon: 'thriller'
	},
	{
		path: 'cinema/movies/child',
		icon: 'children'
	},
	{
		path: 'cinema/movies/family',
		icon: 'family'
	},
	{
		path: 'cinema/movies/documentary',
		icon: 'documentary'
	},
	{
		path: 'cinema/movies/bio',
		icon: 'biographical'
	},
	{
		path: 'cinema/movies/fantastic',
		icon: 'fantastic'
	},
	{
		path: 'cinema/movies/fantasy',
		icon: 'fantasy'
	}
];

export const performanceGenresTypes = [
	{
		path: 'theaters/performances/drama',
		icon: 'drama'
	},
	{
		path: 'theaters/performances/komediya',
		icon: 'comedy'
	},
	{
		path: 'theaters/performances/detskii-spektakl',
		icon: 'children'
	},
	{
		path: 'theaters/performances/musical',
		icon: 'musical'
	},
	{
		path: 'theaters/performances/kukolnyi-spektakl',
		icon: 'puppetShow'
	},
	{
		path: 'theaters/performances/one-actor',
		icon: 'soloPerformance'
	},
	{
		path: 'theaters/performances/opera',
		icon: 'opera'
	},
	{
		path: 'theaters/performances/operetta',
		icon: 'operetta'
	},
	{
		path: 'theaters/performances/telespektakl',
		icon: 'tvperformance'
	},
	{
		path: 'theaters/performances/circus',
		icon: 'circus'
	},
	{
		path: 'theaters/performances/tvorcheskii-vecher',
		icon: 'creativeEvening'
	},
	{
		path: 'theaters/performances/eksperimentalnyi-spektakl',
		icon: 'experimental'
	},
	{
		path: 'theaters/performances/ballet',
		icon: 'ballet'
	}
];

export const lectionGenresTypes = [
	{
		path: 'lectures/movies/cinema',
		icon: 'lectureCinema'
	},
	{
		path: 'lectures/movies/philology',
		icon: 'philology'
	},
	{
		path: 'lectures/movies/history',
		icon: 'historical'
	},
	{
		path: 'lectures/movies/art',
		icon: 'art'
	},
	{
		path: 'lectures/movies/theater',
		icon: 'theater'
	},
	{
		path: 'lectures/movies/science',
		icon: 'science'
	},
	{
		path: 'lectures/movies/pro-kultura-rf',
		icon: 'proKulturaRf'
	},
	{
		path: 'lectures/movies/music',
		icon: 'music'
	},
	{
		path: 'lectures/movies/technologies',
		icon: 'technics'
	},
	{
		path: 'lectures/movies/architecture',
		icon: 'architecture'
	}
];

export const concertsGenresTypes = [
	{
		path: 'music/concerts/avangard',
		icon: 'experimental'
	},
	{
		path: 'music/concerts/avtorskaya-pesnya',
		icon: 'avtorskaya'
	},
	{
		path: 'music/concerts/akustika',
		icon: 'guitar'
	},
	{
		path: 'music/concerts/blues',
		icon: 'blues'
	},
	{
		path: 'music/concerts/vecher-pamyati',
		icon: 'candle'
	},
	{
		path: 'music/concerts/gala-concert',
		icon: 'galaKoncert'
	},
	{
		path: 'music/concerts/gospel',
		icon: 'gospel'
	},
	{
		path: 'music/concerts/jazz',
		icon: 'music'
	},
	{
		path: 'music/concerts/disko',
		icon: 'disco'
	},
	{
		path: 'music/concerts/dlya-detei',
		icon: 'children'
	},
	{
		path: 'music/concerts/cover',
		icon: 'records'
	},
	{
		path: 'music/concerts/classic',
		icon: 'klassika'
	},
	{
		path: 'music/concerts/narodnaya-muzyka',
		icon: 'narodnaya'
	},
	{
		path: 'music/concerts/punk',
		icon: 'punk'
	},
	{
		path: 'music/concerts/pop',
		icon: 'pop'
	},
	{
		path: 'music/concerts/reggae',
		icon: 'reggae'
	},
	{
		path: 'music/concerts/rock-n-roll',
		icon: 'electricGuitar'
	},
	{
		path: 'music/concerts/tanec',
		icon: 'musical'
	},
	{
		path: 'music/concerts/detskii-khor',
		icon: 'detskiiKhor'
	},
	{
		path: 'music/concerts/funk',
		icon: 'guitarNeck'
	},
	{
		path: 'music/concerts/fusion',
		icon: 'experimental'
	},
	{
		path: 'music/concerts/cerkovnaya-muzyka',
		icon: 'bell'
	},
	{
		path: 'music/concerts/elektronika',
		icon: 'equalizing'
	},
	{
		path: 'music/concerts/estrada',
		icon: 'estrada'
	}
];
